import React from 'react'

export type SlideProps = {
  type: 'image' | 'video' | 'color',
  headline: string,
  value: string,
  index?: number,
  subHeadline?: string,
  overlayGradient?: string,
};

const Slide: React.FC<SlideProps> = ({
  type,
  headline,
  value,
  index = 0,
  subHeadline,
  overlayGradient,
}) => {

  return (
    <div className='slide' style={{left: `calc(100% * ${index})`}}>
      <div className="headline" dangerouslySetInnerHTML={{
        __html: headline
      }}></div>
      {subHeadline && (
        <div className="sub-headline">
          {subHeadline}
        </div>
      )}
      <div className="media-content">
        {type === 'video' && (
          <video src={value} autoPlay muted loop></video>
        )}
      </div>
      {overlayGradient && (
        <div className="gradient" style={{background: overlayGradient}}></div>
      )}
    </div>
  );
}

export default Slide;